// ReleaseNotesViewer.tsx
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface ReleaseNote {
  date: string;
  title: string;
  description: string;
}

interface ReleaseNotesViewerProps {
  notes: ReleaseNote[];
}

const ReleaseNotesViewer: React.FC<ReleaseNotesViewerProps> = ({ notes }) => {
  const sortedNotes = [...notes].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-lighter">Release Notes</h2>
      {sortedNotes.map((note, index) => (
        <Card key={index}>
          <CardHeader className="" hasCardAction={false}>
            <CardTitle className="text-lg font-semibold text-primary">{note.title}</CardTitle>
            <p className="text-sm text-muted-foreground">
              <strong>Date:</strong> {new Date(note.date).toLocaleDateString("en-US", { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </CardHeader>
          <CardContent>
            <p className="text-sm leading-relaxed whitespace-pre-line">{note.description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default ReleaseNotesViewer;